import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Firebase configuration - should be getting these from netlify env variables
const firebaseConfig = {
    apiKey: "AIzaSyBlWtP67zogCJfCDASSphONel_s5txH0Ag",
    authDomain: "bot-hive-f023c.firebaseapp.com",
    projectId: "bot-hive-f023c",
    storageBucket: "bot-hive-f023c.appspot.com",
    messagingSenderId: "826220707084",
    appId: "1:826220707084:web:0e642c885f1a3d0b005d29"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db };
